module.exports = __webpack_public_path__ + "img/035.d0045491.jpg";